<template>
  <div class="pt-5 footer-image">
    <div
      v-if="showWechatQr"
      class="modal-backdrop"
      @click="showWechatQr = false"
    >
      <div class="modal">
        <div>
          <qrcode
            :value="'http://example.com'"
            :options="{width: 500, height: 500}"
          />
        </div>
      </div>
    </div>
    <div class="title">
      <h3>关注我们</h3>
      <p>欢迎B站/微信搜索并关注"PositiveGrid"，第一时间获取最新动态</p>
    </div>
    <div class="my-2 cards">
      <!-- <div class="card weibo">
        <img src="@/assets/footer/weibo-qr@2x.png">
        <div class="mt-3">
          <span />
          <p>微博</p>
        </div>
      </div> -->
      <div class="card wechat">
        <img src="@/assets/footer/wechat-qr@2x.png">
        <div class="mt-3">
          <span />
          <p>微信</p>
        </div>
      </div>
      <div class="card bilibili">
        <img src="@/assets/footer/bilibili-qr@2x.png">
        <div class="mt-3">
          <span />
          <p>哔哩哔哩</p>
        </div>
      </div>
    </div>
    <div class="mb-3">
      广州盈声科技有限公司
    </div>
    <!-- <div class="mb-3">
      地址：广州市海珠区江南大道富力天域中心3914
    </div> -->
    <div class="mb-3">
      电话：020-84121029
    </div>
    <div class="mb-3">
      合作沟通：joya.gao@positivegrid.com
    </div>
  </div>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  components: {
    qrcode: VueQrcode
  },
  data () {
    return {
      showWechatQr: false
    }
  },
  methods: {
    openView (url) {
      window.open(url)
    }
  }
}
</script>

<style scoped>
.title h3 {
  font-size: 30px;
}
.title h3, .title p {
  color: white;
  font-weight: 300;
}
.footer-image {
  max-height: 415px;
  padding-left: 20%;
  flex-flow: row wrap;
  align-items: center;
  position: relative;
  background-size: cover;
  background-image: url('../assets/footer.jpg');
  display: flex;
  align-items: center;
}

.footer-image > div {
  flex: 0 1 100%;
}

.cards {
  display: flex;
}

.card {
  margin-left: 30px;
}
.card:first-of-type {
  margin-left: unset;
}

.card span {
  height: 30px;
  width: 30px;
  background-size: cover;
  display: inline-block;
  margin-right: 0.5rem;
}

.card img {
  width: 120px;
  height: 120px;
  object-fit: cover;
}
.card p {
  font-size: 14px;
  color: white;
}
.card div {
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 2rem;
}
.card p > span {
  margin-right: 0.5rem;
}

.weibo span {
  background-image: url('../assets/footer/weibo-logo@2x.png');
}

.wechat span {
  background-image: url('../assets/footer/wechat-logo@2x.png');
}

.bilibili span {
  background-image: url('../assets/footer/bilibili-logo@2x.png');
}

@media screen and (max-width: 768px) {
  .footer-image {
    display: none;
  }
}

.modal-backdrop {
  z-index: 2;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #282828;
  box-shadow: 0 2px 23px 0 rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 40vw;
  height: 40vw;
  justify-content: center;
  align-items: center;
}

.modal canvas {
  height: 30vw !important;
  width: 30vw !important;
}

</style>



// WEBPACK FOOTER //
// src/components/footer-weixin.vue